/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['services/utils'], function(Utils) {
    'use strict';

    return function(data) {
        if (Utils.isString(data)) {
            try {
                data = JSON.parse(data); // aja js has problems and response is not always parsed as it should
            } catch (e) {
                return null;
            }
        }
        if (data.error) {
            return { error: data.error};
        } else if (data.matrix) {
            return data.matrix.map(function(row) {
                return row.map(function(cell) {
                    return cell.response;
                });
            });
        }
        return null;
    };
});



// WEBPACK FOOTER //
// ./model/routing/matrixRouting.js